import Box from "@mui/material/Box";
import React from "react";

import { formKey } from "../../../hooks/useQuoteBoxStructure";
import AccessoriesLocks from "./AccessoriesLocks";
import AccessoriesSafety from "./AccessoriesSafety";
import AccessoriesTying from "./AccessoriesTying";
import { NumberedSectionTitle } from "./FormFields";
import { useStyles } from "../styles";

const Accessories = () => {
  const styles = useStyles();

  return (
    <Box className={styles.inputCard}>
      <NumberedSectionTitle
        number={4}
        titleKey={formKey("SECTIONS.EQUIPMENT")}
      />
      <AccessoriesTying />
      <AccessoriesSafety />
      <AccessoriesLocks />
    </Box>
  );
};

export default Accessories;
